import { createSlice } from "@reduxjs/toolkit";
import { PriceListSummary } from "../../typings/interfaces/responses/price-list-summary-response";
import { getPriceListsAction } from "../actions/priceListsAction";

export interface PriceListsState {
  priceLists: PriceListSummary[];
  priceListsLoading: boolean;
  priceListsError: string | null;
}

const initialState: PriceListsState = {
  priceLists: [],
  priceListsLoading: false,
  priceListsError: null,
};

// Named price lists (Standard, Corporate…). Mutations re-fetch the list, so
// only the list itself lives here.
const priceListsSlice = createSlice({
  name: "priceLists",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getPriceListsAction.pending, (state) => {
        state.priceListsLoading = true;
        state.priceListsError = null;
      })
      .addCase(getPriceListsAction.fulfilled, (state, action) => {
        state.priceListsLoading = false;
        state.priceLists = action.payload ?? [];
      })
      .addCase(getPriceListsAction.rejected, (state, action) => {
        state.priceListsLoading = false;
        state.priceListsError = (action.payload as string) ?? "Failed to load price lists";
      });
  },
});

export default priceListsSlice.reducer;
